import { colors } from '../../colors';
var imageSlider = {
  primaryBgColor: colors.slateGreen,
  secondaryBgColor: colors.white,
  textColorDark: colors.ash,
  textColorLight: colors.white
};
export default imageSlider;